<template>
  <v-select v-model="value" :items="items" item-text="Name" placeholder="Okul Seçiniz"
            item-value="TenantId" outlined hide-details @change="updateTenant"></v-select>
</template>

<script>
import ApiService from '@/core/services/api.service.js'

export default {
  name: 'core-app',
  props: ['value'],
  data() {
    return { items: [], loading: true }
  },
  mounted() {
    this.getDataFromApi()
  },
  methods: {
    getDataFromApi() {
      ApiService.post('https://egitimapi.istem.k12.tr/api/App/app-list', {
        sortBy: ['DisplayOrder'],
        descending: [false],
        rowsPerPage: -1,
        page: 1
      }).then(({ data }) => {
        this.items = data.Results
        this.loading = false

        const tid = localStorage.getItem('TID')
        if (tid)
          this.value = tid
      }).catch(() => (this.loading = false))
    },

    updateTenant(value) {
      localStorage.setItem('TID', value)
      var apiUrl = this.items.find(x => x.TenantId === value)?.ApiUrl
      localStorage.setItem('API_URL', apiUrl)
      ApiService.changeBaseUrl(apiUrl)
    }
  }
}
</script>
